import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Ads from '../Ads/Ads'
import Foot2 from '../Foot2/Foot2'
import NewsDivs from '../NewsDivs/NewsDivs'
import TopBar from '../TopBar/TopBar'

import Spinner from '../Spinner/Spinner'

function SecNew() {
  const { id } = useParams() 
 
  const { num } = useParams()
  const [section, setSection] = useState([{title: "Loading..."}]);

  const [loading, setLoading] = useState(true)
  
  const getSectionnews = async () => {
    setLoading(true)
    const response = await fetch(`http://localhost:9000/newsapi/${id}/${num}`);
    const datum = await response.json()
   
    setSection(datum)
    setLoading(false)
    
   }

  useEffect(() => {
    getSectionnews()
  },[])

  return (
    <div className='secnews'>
       <>
      <TopBar />
      <div className='topicsnews'>
        <div className="head">{ id.replace(",","") } - Nairaland</div>
        <div className="breadcrumbs"> <Link to="/">Nairaland Forum &nbsp;</Link> / <Link to="/">&nbsp; {id}</Link></div>
        <div className="adrate"></div>
        <Ads />
         <div className="pages"> <Link to="/"> (1) </Link>&nbsp; <Link  to="/secnew/2"> (2) </Link> &nbsp; <Link  to="/secnew/3"> (3) </Link>&nbsp; <Link  to="/secnew/4"> (4) </Link>&nbsp; <Link  to="/secnew/5"> (5) </Link> &nbsp;<Link  to="/secnew/6"> (6) </Link>&nbsp; <Link  to="/secnew/7"> (7) </Link>&nbsp; <Link  to="/secnew/8"> (8) </Link>&nbsp; <Link  to="/secnew/9"> (9) </Link> &nbsp;<Link  to="/secnew/10"> (10) </Link>&nbsp; <Link to="">(Create New Topic)</Link>
        </div>
        <div className="topmost"><h4>Topics: </h4>&nbsp;<h4><Link to=""> Post</Link> / &nbsp;</h4><h4><Link to=""> Views </Link> /&nbsp; </h4><h4><Link to=""> Updated </Link> /&nbsp; </h4><h4><Link to=""> New</Link></h4></div>
        <div className="news">
            {loading ? <div className="spinn"><Spinner /> </div> : 
            section.slice(0,49).map((sec) => { return (<Link to="" id={sec} className="newss">  <NewsDivs title={ sec.title}/></Link>)} )
        }
    
        </div>
         <div className="pages">
       <Link to="/"> (1) </Link>&nbsp; <Link  to="/secnew/:id/2"> (2) </Link> &nbsp; <Link  to="/secnew/3"> (3) </Link>&nbsp; <Link  to="/secnew/4"> (4) </Link>&nbsp; <Link  to="/secnew/5"> (5) </Link> &nbsp;<Link  to="/secnew/6"> (6) </Link>&nbsp; <Link  to="/secnew/7"> (7) </Link>&nbsp; <Link  to="/secnew/8"> (8) </Link>&nbsp; <Link  to="/secnew/9"> (9) </Link> &nbsp;<Link  to="/secnew/10"> (10) </Link>&nbsp; <Link to="">(Create New Topic)</Link>
      </div>
        <Ads />
        <div className="online">6 guest(s)</div>
        <div className="go">(Go Up)</div>
      </div>
      <Foot2 />
    </>
    </div>
  )
}

export default SecNew